<template>

  <div  >

    <el-card >
      <!--搜索区域-->

      <el-tabs v-model="activeName" type="card"  @tab-click="tabsHandleClick">
        <el-tab-pane label="购买套餐" name="pay">
          <!-- 订单列表区域 -->
          <el-table :data = "comboMealList"  stripe max-height = "500">
            <el-table-column label = "套餐名称" prop = "name">
              <template slot-scope="scope">
                <el-tag >{{scope.row.name}}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label = "价格" prop = "unitPrice">
              <template slot-scope="scope">
                <el-tag type="success">¥{{scope.row.unitPrice}}/{{scope.row.unit}}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label = "说明" prop = "remark"></el-table-column>
            <el-table-column  label="操作" width="185px">
              <template slot-scope="scope">
                <!-- 修改按钮 -->
                <el-button type="primary" icon="el-icon-thumb" size="mini" @click="buyNow(scope.row)" >立即购买</el-button>
              </template>
            </el-table-column>
          </el-table>


          <el-dialog
            title="下单"
            :close-on-click-modal="false"
            :before-close="dialogClose"
            :visible.sync="buyNowVisible"
            width="70%">


            <div style="padding: 20px">
              <el-steps  simple :active="payActive">
                <el-step title="确认订单" icon="el-icon-edit"/>
                <el-step title="支付订单" icon="el-icon-upload"/>
                <el-step title="支付结果" icon="el-icon-picture"/>
              </el-steps>

              <div class="test2024" v-if="payActive == 1">
                <el-form ref="form" :model="form" label-width="80px">
                  <el-form-item label="套餐规格:">
                    <el-radio-group v-model="form.comboMealId"   >
                      <el-radio  v-for="(item, index) in comboMealList"
                                :key="item.comboMealId" :label="item.comboMealId  "  @change="showOrderComboMeal(item.comboMealId)" border>{{item.name}}</el-radio>
                    </el-radio-group>
                  </el-form-item>

                  <el-form-item label="套餐单价:">
                   <span style="font-weight: bolder"> ¥{{form.comboMeal.unitPrice}}</span>
                  </el-form-item>


                  <el-form-item label="服务时长:">
                    <el-radio-group v-model="form.payAmount" @change="preOrderChange()" >
                      <el-radio label="1" border>1年</el-radio>
                      <el-radio label="2" border>2年(<span style="color: red"> 9折</span> ) </el-radio>
                      <el-radio label="3" border>3年(<span style="color: red"> 8折</span> ) </el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="服务日期:">
                    <el-date-picker
                      disabled
                      v-model="preOrder.showStartTime"
                      type="date"
                      placeholder="">
                    </el-date-picker>
  -
                    <el-date-picker
                      disabled
                      v-model="preOrder.showEndTime"
                      type="date"
                      placeholder="">
                    </el-date-picker>
                  </el-form-item>


                  <el-form-item label="订单金额:">
                    <span style="font-weight: bolder;color: #f60;font-size: x-large">{{preOrder.showTotalPrice}}</span>
                  </el-form-item>

                  <el-form-item label="付款方式:">
                    <el-radio-group v-model="form.payType" >
                      <el-radio label="1" border>
                        <img src="https://hnmykj.oss-cn-hangzhou.aliyuncs.com/xzcx/images/poster/wechatpay2.png" class="wechatpay">
                      </el-radio>

                      <el-radio label="3" border>
                        <img src="https://hnmykj.oss-cn-hangzhou.aliyuncs.com/xzcx/images/poster/yinlianpay.png" class="wechatpay">
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>


                  <el-form-item >
                    <el-button style="margin-top: 20px" type="primary" @click="placeOrder()">确认</el-button>
                  </el-form-item>
                </el-form>

              </div>

              <div v-if="payActive == 2">

                <div>

                  <el-descriptions title="" direction="vertical" :column="4" border>
                    <el-descriptions-item label="订单号"> <span style="font-weight: bolder">{{order.orderNo}}</span> </el-descriptions-item>
                    <el-descriptions-item label="套餐名称" :span="1" > <span style="font-weight: bolder">{{order.comboMealName}}</span> </el-descriptions-item>
                    <el-descriptions-item label="服务时长" :span="1"> <span style="font-weight: bolder">{{order.payAmount}}年</span>  </el-descriptions-item>
                    <el-descriptions-item label="订单金额">
                      <span style="font-weight: bolder;color: #f60">{{order.totalPrice}}</span>
                    </el-descriptions-item>
                  </el-descriptions>


                  <el-divider><i class="el-icon-mobile-phone"></i></el-divider>

                  <div class="centered-div" v-if="order.payType == 1" >
                    <el-alert
                      title="通过扫描微信二维码进行付款，一旦付款成功，您购买的服务将立即生效。"
                      type="warning">
                    </el-alert>
                  </div>

                  <div class="centered-div" v-if="order.payType == 3" >
                    <el-alert
                      title="使用银行转账进行支付，支付成功后请提供成功支付页面的截图或照片作为凭证上传。提交后，我们会核对款项并确认，然后为您开通所选套餐。如有任何疑问，请联系客服。"
                      type="warning">
                    </el-alert>
                  </div>

                  <div class="centered-div" v-if="order.payType == 1" >
                    <!--         微信支付才有二维码           -->
                    <img   v-if="order.payCodeQrUrl  != ''" style="margin-top: 20px;width: 180px;height: 180px" :src="order.payCodeQrUrl">
                  </div>


                  <div class="centered-div" v-if="order.payType == 3" >
                    <!--         网银转账          -->
                    <div>
                      <h1> 收款人: 嘉兴芒鱼信息技术有限公司 </h1>
                      <h1> 开户银行: 中国工商银行嘉兴海宁马桥支行 </h1>
                      <h1> 银行账号: 1204 0864 0910 0016 841</h1>
                    </div>

                    <div class="avatar-uploader-div">
                      <span style="font-weight: bolder">付款凭证: </span>
                      <el-upload
                        class="avatar-uploader"
                        :show-file-list="false"
                        :headers = "headerObj"
                        :action="uploadUrl"
                        :on-success="handleAvatarSuccess"
                        :before-upload="beforeAvatarUpload">
                        <img v-if="order.bankTransferImage" :src="order.bankTransferImage" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                      </el-upload>

                    </div>
                  </div>

                  <div class="centered-div" v-if="order.payType == 3" >
                    <el-button v-if="order.payStatus != 3" style="margin-top: 20px"   type="primary" @click="uploadOrderBankTransferImage(order)">提交审核</el-button>
                    <el-button v-if="order.payStatus == 3" style="margin-top: 20px"   type="primary" @click="uploadOrderBankTransferImage(order)">点击提醒审核</el-button>
                  </div>
                </div>
              </div>

              <div v-if="payActive == 3">
                <el-result v-if="order.payType == 1" icon="success" title="支付成功" subTitle="如有任何问题或需要帮助，请随时联系我们">
                  <template slot="extra">
                    <el-button type="primary" size="medium" @click="paySuccess()"  >完成</el-button>
                  </template>
                </el-result>

                <el-result v-if="order.payType == 3" icon="success" title="提交审核成功" subTitle="如有任何问题或需要帮助，请随时联系我们">
                  <template slot="extra">
                    <el-button type="primary" size="medium" @click="paySuccess()"  >完成</el-button>
                  </template>
                </el-result>
              </div>
            </div>

          </el-dialog>



        </el-tab-pane>


        <el-tab-pane label="订单记录" name="order">
          <!-- 用户列表区域 -->
          <el-table :data="orderList" border stripe>
            <el-table-column prop="orderNo" width="190px" label="订单号">
              <template slot-scope="scope">
                <el-tag type="info">{{scope.row.orderNo}}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="comboMealName" label="详情">
              <template slot-scope="scope">
                <el-tag>{{scope.row.comboMealName}}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="payAmount"  width="90px" label="购买年数">
              <template slot-scope="scope">
                <el-tag >{{scope.row.payAmount}}年</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="totalPrice"  width="90px" label="金额">
              <template slot-scope="scope">
                <el-tag >{{scope.row.totalPrice}}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="payStatusStr"  width="100px" label="状态">
              <template slot-scope="scope">
                <el-tag  v-if="scope.row.payStatus == 0" type="danger">待支付</el-tag>
                <el-tag  v-if="scope.row.payStatus == 1" type="success">支付成功</el-tag>
                <el-tag  v-if="scope.row.payStatus == 2" type="warning">已退款</el-tag>
                <el-tag  v-if="scope.row.payStatus == 3" type="warning">审核中</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="createTime"  width="170px"  label="创建时间">
              <template slot-scope="scope">
                <el-tag type="success">{{scope.row.createTime}}</el-tag>
              </template>
            </el-table-column>
            <el-table-column  fixed="right" label="操作" width="215px">
              <template slot-scope="scope">
                <el-button  type="primary"  size="mini" @click="againPay(scope.row)" > 详情 </el-button>
                <el-button  v-if="scope.row.payStatus == 0"  type="info"  size="mini" @click="deleteOrder(scope.row)" > 删除 </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>


        <el-tab-pane label="我的套餐"  name="my">

          <el-row>
            <el-col :span="6" v-for="(o,index) in companyComboList" :key="index" :offset="1">
              <el-card shadow="hover"  class="box-card">
                <div slot="header" class="clearfix">
                  <span style="font-weight: bolder;font-size: large">{{o.comboMealName}}</span>
<!--                  <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button>-->

                  <span style=" float: right;">
                       <el-tag v-if="o.type == 1" type="success">生效中</el-tag>
                      <el-tag v-if="o.type == 2" type="info">已过期</el-tag>
                  </span>

                </div>
                <div class="text item">
                  <span style="font-weight: bolder;">生效时间:</span> <span>{{o.comboStartTime}}</span>
                </div>
                <div class="text item">
                  <span style="font-weight: bolder;">过期时间:</span> <span>{{o.comboEndTime}}</span>
                </div>
                <div class="text item">
                  <span style="font-weight: bolder;">购买人数:</span> <span>{{o.peopleNumber}}</span>
                </div>
              </el-card>
            </el-col>

          </el-row>


        </el-tab-pane>
      </el-tabs>


      <div style="margin-top: 50px">

        <el-alert
          title=" 如需开具发票，请联系我们的客服。"
          type="info">
        </el-alert>

      </div>


    </el-card>
  </div>
</template>

<script>

export default {
  name: 'Order',
  data() {
    return {
      // 图片上传组件的headers 请求头
      headerObj: {
        accessToken: window.localStorage.getItem('token')
      },
      uploadUrl:this.$http.defaults.baseURL+"upload/uploadImage",
      comboMealList: [],
      orderList: [],
      companyComboList: [],
      activeName: 'pay',
      buyNowVisible:false,
      payActive:1,
      form:{
        comboMealId:0,
        payAmount:'1',
        comboMeal:{},
        payType:'1'
      },
      preOrder:{

      },
      order:{
      },
      timer: null, //定时任务,
      companyId:0
    }
  },
  created() {
    this.getComboMealList();
    this.companyId = JSON.parse( window.localStorage.getItem('company')).companyId;
  },
  methods: {
    async getComboMealList() {
      const { data: res } = await this.$http.get('/comboMeal/comboMealList',{})   //get参数用params获得
      if(res.code !== '10000') {
        return this.$message.error(res.msg)
      }
      this.comboMealList = res.data;
    },
    async getOrderListList() {
      const { data: res } = await this.$http.get('/order/orderPageList?page=1&limit=9999',{})   //get参数用params获得
      if(res.code !== '10000') {
        return this.$message.error(res.msg)
      }
      this.orderList = res.data;
    },
    async getCompanyComboList() {
      const { data: res } = await this.$http.get('/companyCombo/companyComboList',{})   //get参数用params获得
      if(res.code !== '10000') {
        return this.$message.error(res.msg)
      }
      this.companyComboList = res.data;
    },
    async tabsHandleClick(tab, event){
      if(tab.name == "order"){
        this.getOrderListList();
      }

      if(tab.name == "my"){
        this.getCompanyComboList();
      }
    },
    async buyNow(data){
      this.buyNowVisible = true;
      this.payActive = 1;
      this.order={};
      this.showOrderComboMeal(data.comboMealId);
    },
    showOrderComboMeal(comboMealId){
      var comboMealList =  this.comboMealList;
      for (var item of comboMealList) {
        if(comboMealId == item.comboMealId){
          this.form.comboMeal = item;
          this.form.comboMealId = comboMealId;
        }
      }
      this.preOrderChange();
    },
    async paySuccess(){
      this.buyNowVisible = false;
      this.payActive = 1;
    },
    /**
     * 预下单订单
     */
    async  preOrderChange(){
      var form = this.form;
      const { data: res } =await  this.$http.post('/order/preOrder',form)   //get参数用params获得
      if(res.code !== '10000') {
        return this.$message.error(res.msg)
      }
      this.preOrder = res.data;
    },
    /**
     * 下单接口
     */
    async placeOrder(){
      var form = this.form;
      const { data: res } =await  this.$http.post('/order/placeOrder',form)   //get参数用params获得
      if(res.code !== '10000') {
        return this.$message.error(res.msg)
      }
      this.payActive =2;
      this.order = res.data;

      if(res.data.payType == 1){
        this.startTimer(res.data.orderNo);
      }
    },
    /**
     * 检查订单状态
     */
    async  checkOrderStatus(orderNo){
      const { data: res } =await  this.$http.get('/order/pollingOrder',{
        params:{"orderNo":orderNo},
      })   //get参数用params获得
      if(res.code !== '10000') {
        return;
      }
      this.payActive =3;
      this.stopTimer()
    },
    startTimer(orderNo) {
      this.timer = setInterval(() => {
        this.checkOrderStatus(orderNo);
      }, 2000);
    },
    stopTimer() {
      clearInterval(this.timer);
      console.log('定时器已停止');
    },
    /**
     * 下单页面关闭事件
     */
    dialogClose(){
      this.buyNowVisible = false;
      this.stopTimer();
    },
    /**
     * 查看详情
     * @param order
     * @returns {Promise<void>}
     */
    async againPay(order){
      this.activeName = "pay";
      this.buyNowVisible = true;
      this.payActive =2;
      this.order = order;

      const  payType = this.order.payType;
      const  payStatus = this.order.payStatus;
      if(payType == 1 && payStatus == 0){
        this.startTimer( this.order.orderNo);
      }
    },
    async deleteOrder(order){
      const deleteOrderParam = {"orderId":order.orderId};
      const { data: res } =await  this.$http.post('/order/deleteOrder',deleteOrderParam)   //get参数用params获得
      if(res.code !== '10000') {
        return this.$message.error(res.msg)
      }

      this.$message.success(res.msg);
      this.getOrderListList();
    },
    handleAvatarSuccess(res, file) {
      this.order.bankTransferImage = res.data.filePath;
    },
    beforeAvatarUpload(file) {
     return;
    },
    async uploadOrderBankTransferImage(order){
      if(order.bankTransferImage == null || order.bankTransferImage == undefined
        || order.bankTransferImage == ''){
        return this.$message.error("请上传支付凭证");
      }

      const orderParam = {"orderId":order.orderId,"bankTransferImage":order.bankTransferImage};
      const { data: res } =await  this.$http.post('/order/uploadOrderBankTransferImage',orderParam)   //get参数用params获得
      if(res.code !== '10000') {
        return this.$message.error(res.msg)
      }

      this.payActive = 3;
    }
  }
}
</script>

<style lang="less" scoped>

  .avatar-uploader-div{
    border: 2px dashed #d9d9d9;
    margin-left: 20px;
  }

  .avatar-uploader .el-upload {

    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 200px;
    height: 200px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 200px;
    height: 200px;
    display: block;
  }



  .el-cascader{
  width: 100%;
}
.item {
  padding: 5px 0;
}

.box-card {
  width: 300px;
}

.test2024{
  padding: 30px;
}

  .wechatpay{
    width: 80px;
    height: 18px;
  }


.centered-div {
  display: flex;
  justify-content: center;
  align-items: center;
}

.centered-div-v2 {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
}


</style>



// WEBPACK FOOTER //
// src/components/order/Order.vue